var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 5,
    fill: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.648 9.016C9.17067 9.016 9.59533 8.93667 9.922 8.778C10.2487 8.61933 10.4867 8.39533 10.636 8.106C10.7947 7.81667 10.874 7.48067 10.874 7.098C10.874 6.49133 10.6967 6.02 10.342 5.684C9.99667 5.348 9.432 5.18 8.648 5.18H6.31V9.016H8.648ZM11.98 7.098C11.98 7.48067 11.9147 7.84933 11.784 8.204C11.6627 8.54933 11.4667 8.85733 11.196 9.128C10.9253 9.39867 10.58 9.61333 10.16 9.772C9.74 9.92133 9.236 9.996 8.648 9.996H6.31V14H5.19V4.2H8.648C9.41333 4.2 10.0387 4.33067 10.524 4.592C11.0187 4.85333 11.3827 5.20333 11.616 5.642C11.8587 6.08067 11.98 6.566 11.98 7.098Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.418e34675fcac4e8e6877a79b43ffb72.svg";
export { ForwardRef as ReactComponent };